import { createFileRoute } from "@tanstack/react-router";
import { ExtratoBancarioDetalhePage } from "@/pages/ExtratoBancarioDetalhePage";

export const Route = createFileRoute("/extratos-bancarios/$id")({
  head: () => ({
    meta: [{ title: "Detalhe do Extrato — AXIS Comprovantes" }],
  }),
  component: ExtratoBancarioDetalhePage,
});
